import React, { Component } from "react";
import axios from "axios";
import _ from "lodash";

class LogoBar extends Component {
  constructor() {
    super();
    this.state = {
      data: null
    };
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com";

    axios.get(SITE_URL + "/wp-json/wp/v2/logos?per_page=100").then(res => {
      this.setState(
        {
          data: res.data
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  renderLogoBar() {
    const { page } = this.props,
      { data } = this.state;
    if (data) {
      return _.map(data, (o, i) => {
        if (o.acf.category[0].name === page) {
          return (
            <div key={i} className="logo-item">
              <img alt="icon" src={o.acf.image_file} />
            </div>
          );
        }
      });
    }
  }

  render() {
    return (
      <div className="logo-bar">
        <h4>Clients Who Rely on OnCourse</h4>
        {this.renderLogoBar()}
      </div>
    );
  }
}

export default LogoBar;



// WEBPACK FOOTER //
// ./src/components/LogoBar.js